var _a;
import { AssignTicketTypes } from './rule.i';
import { RuleActionType, LabelsActionTypes, SendEmailActionTypes } from './rule-actions-type.enum';
export var subActionsMap = (_a = {},
    _a[RuleActionType.TICKET_SET_LABELS] = [LabelsActionTypes.ADD, LabelsActionTypes.REMOVE, LabelsActionTypes.REPLACE],
    _a[RuleActionType.TICKET_SET_STATUS] = [],
    _a[RuleActionType.TICKET_ADD_CC_USERS] = [],
    _a[RuleActionType.TICKET_ASSIGN] = [AssignTicketTypes.USER, AssignTicketTypes.GROUP],
    _a[RuleActionType.TICKET_SET_BRAND] = [],
    _a[RuleActionType.BAN_USER] = [],
    _a[RuleActionType.TICKET_DELETE] = [],
    _a[RuleActionType.TICKET_MARK_SPAM] = [],
    _a[RuleActionType.TICKET_MARK_HAM] = [],
    _a[RuleActionType.TICKET_ADD_AGENT_REPLY] = [],
    _a[RuleActionType.TICKET_SET_PRIORITY] = [],
    _a[RuleActionType.SEND_EMAIL] = [
        SendEmailActionTypes.TICKET_OWNER, SendEmailActionTypes.ACCOUNT_OWNER, SendEmailActionTypes.AGENTS,
        SendEmailActionTypes.GROUPS, SendEmailActionTypes.EMAILS, SendEmailActionTypes.ALL_ADMINS,
        SendEmailActionTypes.ALL_AGENTS, SendEmailActionTypes.ALL
    ],
    _a[RuleActionType.TICKET_SET_BOOLEAN_CUSTOM_FIELD] = [],
    _a[RuleActionType.TICKET_SET_VALUE_TO_CUSTOM_FIELD] = [],
    _a[RuleActionType.TICKET_ADD_RELATED_ARTICLES] = [],
    _a[RuleActionType.TICKET_SET_LANGUAGE] = [],
    _a[RuleActionType.TICKET_SET_SLA_POLICY] = [],
    _a);
//# sourceMappingURL=rule-actions.i.js.map